import Vue from 'vue';
import Vuetify, {VApp, VContent, VBtn, VIcon, VTabs, VTab, VTabsItems, VTabItem, VTabsSlider, VDataTable,
  VAlert, VChip, VRow, VCol, VDialog, VCard, VCardTitle, VCardText, VCardActions, VContainer, VTextField, VSpacer,
  VSelect, VCheckbox
} from "vuetify/lib"
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify, {components: {
    VApp,
    VContent,
    VBtn,
    VIcon,
    VTabs,
    VTab,
    VTabsItems,
    VTabItem,
    VTabsSlider,
    VDataTable,
    VAlert,
    VChip,
    VRow, VCol, VDialog, VCard, VCardTitle, VCardText, VCardActions, VContainer, VTextField, VSpacer,
    VSelect, VCheckbox
  }})

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#2B7C74",
        accent: "#E89F2B"
      }
    }
  }}

export default new Vuetify(opts)
